export class AvailablePeriodsInput {
  constructor(
    public roomId: number,
    public hoursDuration: number,
    public minutesDuration: number,
    public dateFrom: Date,
    public dateTo: Date
  ) {}
}
